import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-arizona-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./arizona-state-form.component.html",
  styleUrl: "./arizona-state-form.component.scss",
})
export class ArizonaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
